import { render } from "./Trend.vue?vue&type=template&id=43a815b0&bindings={}"
import script from "./Trend.vue?vue&type=script&lang=ts"
export * from "./Trend.vue?vue&type=script&lang=ts"
script.render = render

export default script